/* eslint-disable @typescript-eslint/explicit-function-return-type */
const registrations = [
    // {
    //   name: 'example',
    //   component: () => import(/* webpackChunkName: example */ './example/ExampleRoot'),
    // },
    {
        name: 'FAQListing',
        component: () => import(/* webpackChunkName: faqListing */ './FAQs/FAQListingRoot'),
    },
    {
        name: 'AwardsListing',
        component: () => import(/* webpackChunkName: awardsListing */ './Awards/AwardsListingRoot'),
    },
    {
        name: 'EligibilityChecker',
        component: () => import(/* webpackChunkName: eligibilityChecker */ './Eligibility/EligibilityRoot'),
    },
    {
        name: 'ResourceListing',
        component: () => import(/* webpackChunkName: resourceListing */ './Resource/ResourceListingRoot'),
    },
    {
        name: 'ToolsListing',
        component: () => import(/* webpackChunkName: toolsListing */ './Tools/ToolsListingRoot'),
    },
];
export default registrations;
